import { combineReducers } from 'redux';

import libraryCategoryReducer from './category';
import libraryDiscountReducer from './discount';
import libraryGratuityReducer from './gratuity';
import libraryItemReducer from './item';
import libraryModifierReducer from './modifier';
import libraryTaxReducer from './tax';
import librarySalesTypeReducer from './salesType';
import libraryBrandReducer from './brand';
import libraryBundlePackage from './bundlePackage';

export default combineReducers({
  category: libraryCategoryReducer,
  discount: libraryDiscountReducer,
  gratuity: libraryGratuityReducer,
  item: libraryItemReducer,
  modifier: libraryModifierReducer,
  tax: libraryTaxReducer,
  salesType: librarySalesTypeReducer,
  brand: libraryBrandReducer,
  bundlePackage: libraryBundlePackage,
});
